import {
    CacheOptions,
    Configuration,
    IPublicClientApplication,
    PublicClientApplication,
} from "@azure/msal-browser";

export class MsalFactory {
    private instance: IPublicClientApplication | null = null;
    private cacheConfig: CacheOptions = {
        cacheLocation: "localStorage",
    };

    public async getOrCreateMsalInstance(
        config: Configuration
    ): Promise<IPublicClientApplication> {
        if (this.instance) {
            return this.instance;
        }

        this.instance = new PublicClientApplication({
            ...config,
            cache: { ...config.cache, ...this.cacheConfig },
        });
        await this.instance.initialize();

        return this.instance;
    }
}
